import { FC, useEffect, useState } from 'react';

import toast, { Toaster } from 'react-hot-toast';

import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/reducer/store';

import {
  actionGetRoutes,
  actionGetRoutesFilters,
} from '../../../redux/action/projects/actionRoutes';
import { actionGetProjectsList } from "../../../redux/action/projects/actionProjects";
import {
  reducerRoutesInputValues,
  reducerRoutesStatus,
  reducerSortRoutesList,
  reducerSetVacantCBnew,
  reducerGetRoutes,
} from '../../../redux/reducer/projects/reducers/reducerRoutesList';

import { reducerSetCurrentProject } from '../../../redux/reducer/projects/reducers/reducerProjectsList';

import clsx from 'clsx';

import { formatDateWithDots, formatTimeWoSeconds } from '../../../utils/formatDate';

import { generateStyles } from '../../../utils/generateToastStyles';

import { ReactComponent as AlarmIcon } from '../../../assets/icons/toast-error.svg';

import Loader from '../../custom/loader/loader';
import Select from '../../custom/select/select';
import CustomMultiSelect from '../../custom/customMultiSelect/customMultiSelect';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import Pagination from '../../pagination/pagination';
import LimitSelect from '../../custom/limitSelect/limitSelect';
import SortIcon from '../../custom/sortIcon/sortIcon';

import '../table.scss';
import styles from './projects.module.scss';

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const checkinTypeOptions = [
  { value: '', label: 'Все' },
  { value: 'yes', label: 'Заполнен' },
  { value: 'no', label: 'Не заполнен' },
];

interface RoutesProps {
  checked?: boolean;
  alarmSync: boolean;
  canBeAttachedToVacancy: boolean;
  coefficient: number;
  endTime: string;
  income: number;
  login: string;
  merch: string;
  places: number;
  plannedWage: number;
  project: { id: number, name: string };
  reports: number;
  routeNo: number;
  routeStatusType: { [key: string]: string };
  startTime: string;
  status: { [key: string]: string };
  sv: string;
  type: { [key: string]: string };
  visits: number;
  visitsDiff: number;
  visitsPlan: number;
  workload: number;
}

interface ProjectRoutesProps {
  currentRoute: number;
}

const TableProjectRoutes: FC<ProjectRoutesProps> = ({ currentRoute }) => {
  const dispatch = useDispatch<AppDispatch>();

  const {
    employeeStatusOptions,
    routeVisitTypeOptions,
    clientsStatusMessage,
    vsupervisorOptions,
    routesInputValues,
    totalPlannedWage,
    routeTypeOptions,
    totalVisitsDiff,
    routesSettings,
    clientsStatus,
    merchOptions,
    totalIncome,
    totalPlaces,
    vacantCBnew,
    totalVisits,
    syncFalse,
    svOptions,
    syncTrue,
    count,
    limit,
    data,
    page,
  } = useSelector((state: any) => state.projects.routes);
  const { isOpenSidebar } = useSelector((state: any) => state.user.user);
  const { claims } = useSelector((state: any) => state.user.user.data);
  const [isInputChange, setIsInputChange] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [sortOptions, setSortOptions] = useState({ column: 'none', direction: 'none' })
  const [isPending, setIsPending] = useState<boolean>(false);
  const actualLimit =
    JSON.parse(localStorage.getItem('pageLimit') as string) || limit;
  const sync = `${syncTrue}/${syncFalse}`;
  const requestStatusOptions = [
    {
      status: 201,
      successMessage: clientsStatusMessage,
    },
    {
      status: 401,
      errorMessage: clientsStatusMessage,
    },
    {
      status: 500,
      errorMessage: 'Что-то пошло не так на стороне сервера',
    },
    {
      status: 3,
      errorMessage: 'Выберите маршрут',
    },
  ];

  const resetPages = () => {
    setCurrentPage(1);
    setStartPage(1);
  };

  const handleChange = (newLimit: number, newPage: number) => {
    setIsPending(true);
    dispatch(actionGetRoutes(newLimit, newPage)).then(() => {
      setIsPending(false);
    });
    localStorage.setItem('pageLimit', JSON.stringify(newLimit));
  };

  const handleChangeLimits = (option: { value: number }) => {
    handleChange(option.value, 1);
    resetPages();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (value === '') {
      const updatedInputValues = { ...routesInputValues };
      if (name === 'routeNo') {
        updatedInputValues[name] = [];
      } else {
        delete updatedInputValues[name];
      }
      dispatch(reducerRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerRoutesInputValues({ ...routesInputValues, [name]: name === 'name' ? value : [value] })
      );
    }
    setIsInputChange(true);
  };

  const handleFromFilter = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const value = event.target.value;
    if (value === '') {
      const updatedInputValues = { ...routesInputValues };
      updatedInputValues[name] = { ...routesInputValues[name], from: null };
      dispatch(reducerRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerRoutesInputValues({
          ...routesInputValues,
          [name]: { ...routesInputValues[name], from: parseFloat(value) },
        })
      );
    }
    setIsInputChange(true);
  }

  const handleToFilter = (event: React.ChangeEvent<HTMLInputElement>, name: string) => {
    const value = event.target.value;
    if (value === '') {
      const updatedInputValues = { ...routesInputValues };
      updatedInputValues[name] = { ...routesInputValues[name], to: null };
      dispatch(reducerRoutesInputValues(updatedInputValues));
    } else {
      dispatch(
        reducerRoutesInputValues({
          ...routesInputValues,
          [name]: { ...routesInputValues[name], to: parseFloat(value) },
        })
      );
    }
    setIsInputChange(true);
  }

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      setIsPending(true);
      dispatch(actionGetRoutes(limit, page)).then(() => {
        setIsPending(false);
      });
      setIsInputChange(false);
      resetPages();
    }
  };

  const selectChange = (event: { value: string, label: string }, name: string) => {
    const value = event.value;
    if (value === '') {
      const updatedInputValues = { ...routesInputValues };
      updatedInputValues[name] = [];
      dispatch(reducerRoutesInputValues(updatedInputValues));
    } else {
      if (name === 'hasCheckIn' || name === 'hasCheckOut' || name === 'hasSync') {
        dispatch(
          reducerRoutesInputValues({
            ...routesInputValues,
            [name]: value === 'yes',
          })
        );
      } else {
        dispatch(
          reducerRoutesInputValues({
            ...routesInputValues,
            [name]: [value],
          })
        );
      }
    }
    setIsPending(true);
    dispatch(actionGetRoutes(limit, page)).then(() => {
      setIsPending(false);
    });
    setIsInputChange(false);
    resetPages();
  };

  const selectSort = (column: string) => {
    if (sortOptions.column !== column) {
      setSortOptions({
        column: column,
        direction: 'up'
      })
    } else {
      setSortOptions({
        column: column,
        direction: sortOptions.direction === 'none' ? 'up' : sortOptions.direction === 'up' ? 'down' : 'none'
      })
    }
  }

  const getRowClassName = (statusObject: { [key: string]: string }) => {
    if (statusObject) {
      const statusKey = Object.keys(statusObject)[0];
      if (statusKey === 'VacantNoVacancy') {
        return "red__row";
      } else if (statusKey === 'ReplacementNoVacancy') {
        return "yellow__row";
      } else if (statusKey === 'ActiveNoVacancy') {
        return "lightBlue__row";
      }
    }
    return "";
  };

  useEffect(() => {
    if (data) {
      const temp = data.map((item: RoutesProps) => {
        return { ...item, checked: false }
      })
      dispatch(reducerSetVacantCBnew(temp))
    }
  }, [data, dispatch])

  const handleCBrow = (route: RoutesProps) => {
    const updatedCBnew = vacantCBnew.map((item: RoutesProps) => {
      if (item.routeNo === route.routeNo && item.project.id === route.project.id) {
        return {
          ...item,
          checked: !item.checked,
        };
      } else {
        return item;
      }
    });
    dispatch(reducerSetVacantCBnew(updatedCBnew))
  };
  const renderVisibleRows = () => {
    const visibleRows: any = [];

    for (let i = 0; i < data.length; i++) {
      const route = data[i];
      if (route !== undefined) {
        let disableCheckbox = false
        if (route.routeStatusType && ('Active' === Object.keys(route.routeStatusType)[0]) && Object.keys(route.status)[0] === 'OutSick' && Object.keys(route.status)[0] !== 'Vacation') {
          disableCheckbox = true
        }
        visibleRows.push(
          <tr className={clsx('active__link_tr', getRowClassName(route?.routeStatusType))} key={i}>
            <td>
              <input
                disabled={(claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) ?
                  (!route.routeStatusType || disableCheckbox || !route.canBeAttachedToVacancy) : true}
                onChange={() => handleCBrow(route)}
                className='relative__elem'
                type='checkbox'
              />
            </td>

            {routesSettings.includes('routeNo') && <td>
              <span className='relative__elem'>{route.routeNo}</span>
            </td>}

            {routesSettings.includes('merch') && <td>
              <span className='relative__elem'>{route.merch}</span>
            </td>}

            {routesSettings.includes('visitType') && <td>
              <span className='relative__elem'>
                {route?.routeType && Object.values(route.routeType)}
              </span>
            </td>}

            {routesSettings.includes('sync') && <td>
              <span className='relative__elem'>
                {route?.syncTime && formatDateWithDots(route.syncTime)}
              </span>
            </td>}

            {routesSettings.includes('checkin') && <td className={styles.flexCenter}>
              <span className='relative__elem'>
                {route?.checkIn && formatDateWithDots(route.checkIn)}
              </span>
              {route.alarmSync && (
                <span>
                  <AlarmIcon />
                </span>
              )}
            </td>}

            {routesSettings.includes('checkout') && <td>
              <span className='relative__elem'>
                {route?.checkOut && formatDateWithDots(route.checkOut)}
              </span>
            </td>}

            {routesSettings.includes('smena') && <td>
              <span className='relative__elem'>
                {formatTimeWoSeconds(route.startTime)}&nbsp;-&nbsp;{formatTimeWoSeconds(route.endTime)}
              </span>
            </td>}

            {routesSettings.includes('plan') && <td>
              <span className='relative__elem'>{route.visits}</span>
            </td>}

            {routesSettings.includes('sdano') && <td>
              <span className='relative__elem'>
                {route.visits - route.visitsDiff}
              </span>
            </td>}

            {routesSettings.includes('diff') && <td>
              <span className='relative__elem'>{route.visitsDiff}</span>
            </td>}

            {routesSettings.includes('login') && <td>
              <span className='relative__elem'>{route.login}</span>
            </td>}

            {routesSettings.includes('employeeStatus') && <td>
              <span className='relative__elem'>
                {Object.values(route.status)}
              </span>
            </td>}

            {routesSettings.includes('routeType') && <td>
              <span className='relative__elem'>
                {route.routeStatusType && Object.values(route.routeStatusType)}
              </span>
            </td>}

            {routesSettings.includes('vacancyName') && <td>
              <span className='relative__elem'>
                {(claims.includes('admin') || claims.includes('recruiting:vacancy:view')) ?
                  <a href={`/recruiting/vacancy/${route?.vacancy?.id}`} className="report__link">{route?.vacancy?.name}</a>
                  : <span> {route?.vacancy?.name} </span>}
              </span>
            </td>}

            {routesSettings.includes('vsv') && <td>
              <span className='relative__elem'>{route.vsv}</span>
            </td>}

            {routesSettings.includes('supervisor') && <td>
              <span className='relative__elem'>{route.sv}</span>
            </td>}

            {routesSettings.includes('tt') && <td>
              <span className='relative__elem'>{route.places}</span>
            </td>}

            {routesSettings.includes('visitsOnWeek') && <td>
              <span className='relative__elem'>{route.visitsPlan && route.visitsPlan}</span>
            </td>}

            {routesSettings.includes('income') && <td>
              <span className='relative__elem'>{route.income}</span>
            </td>}

            {routesSettings.includes('plannedWage') && <td>
              <span className='relative__elem'>{route.plannedWage}</span>
            </td>}
          </tr>
        );
      }
    }

    return visibleRows;
  };

  useEffect(() => {
    const touchedInputs = ['posClientId', 'planVisits', 'income', 'wage'];
    const handleDocumentClick = (event: React.ChangeEvent<HTMLInputElement> | Event): void => {
      const inputEvent = event as React.ChangeEvent<HTMLInputElement>;
      if (!touchedInputs.includes(inputEvent.target.name) && isInputChange) {
        setIsPending(true);
        dispatch(actionGetRoutes(limit, page)).then(() => {
          setIsPending(false);
        });
        setIsInputChange(false);
        resetPages();
      }
    };
    if (isInputChange) {
      document.addEventListener('click', handleDocumentClick);
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
    } else
      return () => {
        document.removeEventListener('click', handleDocumentClick);
      };
  }, [dispatch, isInputChange, limit, page]);

  useEffect(() => {
    const currentProject = { project: [{ id: currentRoute }] }
    dispatch(reducerSetCurrentProject(currentProject))
  }, [currentRoute, dispatch])

  useEffect(() => {
    setIsPending(true);
    dispatch(actionGetRoutes(limit, page)).then(() => {
      setIsPending(false);
    });
    const data = [
      {
        id: currentRoute,
        name: 'string',
      },
    ];
    dispatch(actionGetRoutesFilters(data));
  }, [dispatch, currentRoute, limit, page]);

  useEffect(() => {
    dispatch(actionGetProjectsList(actualLimit, page))
  }, [actualLimit, dispatch, page]);

  useEffect(() => {
    dispatch(reducerSortRoutesList(sortOptions))
  }, [dispatch, sortOptions])

  useEffect(() => {
    requestStatusOptions.forEach((option: { status: number, successMessage?: string, errorMessage?: string, }) => {
      if (clientsStatus === option.status) {
        toast.dismiss();

        toast(
          t => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false)
        );
      }
    });

    dispatch(reducerRoutesStatus(null));
    // eslint-disable-next-line
  }, [dispatch, clientsStatus]);

  useEffect(() => {
    dispatch(reducerGetRoutes({ data: [] }))
  }, [dispatch])
  return (
    <>
      <div className='loader__wrapper'>{isPending && <Loader />}</div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
          isOpenSidebar &&
          'active__table',
          !isOpenSidebar && 'closed__table',
          'table'
        )}
      >
        <Toaster position='top-center' toastOptions={{ duration: 1500 }} />

        <div className={styles.table}>
          <div className={styles.table__wrp}>
            <table>
              <thead>
                <tr>
                  <th className='reports__checkbox_block'></th>
                  {routesSettings.includes('routeNo') && <th className='filter__number_block'>
                    <div>
                      <input
                        defaultValue={
                          routesInputValues.routeNo && routesInputValues.routeNo
                        }
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        name='routeNo'
                        placeholder=' '
                        type='number'
                      />
                      <label>№</label>
                    </div>
                  </th>}

                  {routesSettings.includes('merch') && <th>
                    <div className='routes__multiselect_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerRoutesInputValues}
                        inputValues={routesInputValues}
                        action={actionGetRoutes}
                        options={merchOptions}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName='routes'
                        placeholder='Мерчендайзер'
                        name='merch'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('visitType') && <th>
                    <div className='filter__number_block'>
                      <Select
                        defaultValue={
                          routesInputValues.routeType &&
                          routesInputValues.routeType.length &&
                          routeVisitTypeOptions.find(
                            (option: { value: string, label: string }) =>
                              option.value === routesInputValues.routeType[0]
                          )
                        }
                        isShowPlaceholder={
                          !!routesInputValues.routeType?.length ||
                          routesInputValues.routeType === undefined
                        }
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'routeType')
                        }
                        options={routeVisitTypeOptions}
                        className='users__filter'
                        placeholder='Тип посещения'
                        name='visitType'
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('sync') && <th>
                    <div className='routes__multiselect_block'>
                      <Select
                        defaultValue={routesInputValues.hasSync && checkinTypeOptions.find((option: { value: string }) => {
                          return option.value === 'yes';
                        })}
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'hasSync')
                        }
                        options={checkinTypeOptions}
                        className='users__filter'
                        placeholder={`Синхронизация ${sync}`}
                        name='sync'
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('checkin') && <th>
                    <div
                      className={clsx('filter__number_block', styles.checkin)}
                    >
                      <Select
                        defaultValue={routesInputValues.hasCheckIn && checkinTypeOptions.find((option: { value: string }) => {
                          return option.value === 'yes';
                        })}
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'hasCheckIn')
                        }
                        options={checkinTypeOptions}
                        className='users__filter'
                        placeholder='Первый чекин'
                        name="reviewStatuses"
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('checkout') && <th>
                    <div className='filter__number_block'>
                      <Select
                        defaultValue={routesInputValues.hasCheckOut && checkinTypeOptions.find((option: { value: string }) => {
                          return option.value === 'yes';
                        })}
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'hasCheckOut')
                        }
                        options={checkinTypeOptions}
                        className='users__filter'
                        placeholder='Последний чекаут'
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('smena') && <th className='filter__number_block'>
                    <div className={styles.sortCell}>
                      <span className='filter__title'>Смена</span>
                      <span data-name={"startTime"} onClick={() => selectSort("startTime")}>
                        <SortIcon state={sortOptions} target="startTime" />
                      </span>
                    </div>
                  </th>}

                  {routesSettings.includes('plan') && <th className='filter__number_block'>
                    <div className={styles.sortCell}>
                      <span className='filter__title'>План</span>
                      <span data-name={"visits"} onClick={() => selectSort("visits")}>
                        <SortIcon state={sortOptions} target="visits" />
                      </span>
                    </div>
                  </th>}

                  {routesSettings.includes('sdano') && <th className='filter__number_block'>
                    <div className={styles.sortCell}>
                      <span className='filter__title'>Сдано</span>
                      <span data-name={"sdano"} onClick={() => selectSort("sdano")}>
                        <SortIcon state={sortOptions} target="sdano" />
                      </span>
                    </div>
                  </th>}

                  {routesSettings.includes('diff') && <th className='filter__number_block'>
                    <div className={styles.sortCell}>
                      <span className='filter__title'>Разница</span>
                      <span data-name={"visitsDiff"} onClick={() => selectSort("visitsDiff")}>
                        <SortIcon state={sortOptions} target="visitsDiff" />
                      </span>
                    </div>
                  </th>}

                  {routesSettings.includes('login') && <th style={{ minWidth: '280px' }}>
                    <div className='routes__multiselect_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerRoutesInputValues}
                        inputValues={routesInputValues}
                        action={actionGetRoutes}
                        options={merchOptions}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName='routes'
                        placeholder='Логин/Локация'
                        name='merch'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('employeeStatus') && <th>
                    <div className='filter__number_block'>
                      <Select
                        defaultValue={
                          routesInputValues.employeeStatus &&
                          routesInputValues.employeeStatus.length &&
                          employeeStatusOptions.find(
                            (option: { value: string, label: string }) =>
                              option.value ===
                              routesInputValues.employeeStatus[0]
                          )
                        }
                        isShowPlaceholder={false}
                        propsChange={(event: { value: string, label: string }) =>
                          selectChange(event, 'employeeStatus')
                        }
                        options={employeeStatusOptions}
                        className='users__filter'
                        placeholder='Статус сотрудника'
                        name='employeeStatus'
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('routeType') && <th>
                    <div className='routes__multiselect_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerRoutesInputValues}
                        inputValues={routesInputValues}
                        action={actionGetRoutes}
                        options={routeTypeOptions}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName='type1'
                        placeholder='Тип маршрута'
                        name='routeStatusType'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('vacancyName') && <th style={{ minWidth: '280px' }}>
                    <div className='filter__block'>
                      <input
                        defaultValue={
                          routesInputValues.name &&
                          routesInputValues.name
                        }
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoComplete='off'
                        placeholder=' '
                        name='name'
                        type='text'
                      />
                      <label>Название вакансии</label>
                    </div>
                  </th>}

                  {routesSettings.includes('vsv') && <th>
                    <div className='routes__multiselect_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerRoutesInputValues}
                        inputValues={routesInputValues}
                        action={actionGetRoutes}
                        options={vsupervisorOptions}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName='routes'
                        placeholder='ВСВ'
                        name='vsv'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('supervisor') && <th>
                    <div className='routes__multiselect_block'>
                      <CustomMultiSelect
                        setLoading={setIsPending}
                        reducer={reducerRoutesInputValues}
                        inputValues={routesInputValues}
                        action={actionGetRoutes}
                        options={svOptions}
                        isShowPlaceholder={true}
                        resetPages={resetPages}
                        pageName='routes'
                        placeholder='Супервайзер'
                        name='sv'
                        limit={limit}
                      />
                    </div>
                  </th>}

                  {routesSettings.includes('tt') && <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Кол-во ТТ на маршруте
                      </span>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.posNum.from && routesInputValues.posNum.from
                          }
                          onChange={(event) => handleFromFilter(event, 'posNum')}
                          onKeyPress={handleKeyPress}
                          name='posClientId'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.posNum.to && routesInputValues.posNum.to
                          }
                          onChange={(event) => handleToFilter(event, 'posNum')}
                          onKeyPress={handleKeyPress}
                          name='posClientId'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {routesSettings.includes('visitsOnWeek') && <th>
                    <div className={styles.fromToFilter}>
                      <span className={styles.widthSpan}>
                        Плановое кол-во визитов в неделю
                      </span>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.planVisits.from && routesInputValues.planVisits.from
                          }
                          onChange={(event) => handleFromFilter(event, 'planVisits')}
                          onKeyPress={handleKeyPress}
                          name='planVisits'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.planVisits.to && routesInputValues.planVisits.to
                          }
                          onChange={(event) => handleToFilter(event, 'planVisits')}
                          onKeyPress={handleKeyPress}
                          name='planVisits'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {routesSettings.includes('income') && <th>
                    <div className={styles.fromToFilter}>
                      <span>Выручка</span>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.income.from && routesInputValues.income.from
                          }
                          onChange={(event) => handleFromFilter(event, 'income')}
                          onKeyPress={handleKeyPress}
                          name='income'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.income.to && routesInputValues.income.to
                          }
                          onChange={(event) => handleToFilter(event, 'income')}
                          onKeyPress={handleKeyPress}
                          name='income'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}

                  {routesSettings.includes('plannedWage') && <th>
                    <div className={styles.fromToFilter}>
                      <span>Зарплата</span>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.wage.from && routesInputValues.wage.from
                          }
                          onChange={(event) => handleFromFilter(event, 'wage')}
                          onKeyPress={handleKeyPress}
                          name='wage'
                          placeholder=' '
                          type='number'
                        />
                        <label>От</label>
                      </div>
                      <div className='filter__number_block'>
                        <input
                          defaultValue={
                            routesInputValues.wage.to && routesInputValues.wage.to
                          }
                          onChange={(event) => handleToFilter(event, 'wage')}
                          onKeyPress={handleKeyPress}
                          name='wage'
                          placeholder=' '
                          type='number'
                        />
                        <label>До</label>
                      </div>
                    </div>
                  </th>}
                </tr>
              </thead>
              <tbody>{renderVisibleRows()}</tbody>

              {data.length > 0 && (
                <tfoot className={styles.tFooter}>
                  <tr>

                    <td>
                      <span>Итого</span>
                    </td>

                    {routesSettings.includes('routeNo') && <td>
                      <span></span>
                    </td>}
                    {routesSettings.includes('merch') && <td>
                    </td>}
                    {routesSettings.includes('visitType') && <td>
                    </td>}
                    {routesSettings.includes('sync') && <td>
                    </td>}
                    {routesSettings.includes('checkin') && <td>
                    </td>}
                    {routesSettings.includes('checkout') && <td>
                    </td>}
                    {routesSettings.includes('smena') && <td>
                    </td>}
                    {routesSettings.includes('plan') &&
                      <td>
                        <span className='relative__elem'>{totalVisits}</span>
                      </td>
                    }
                    {routesSettings.includes('sdano') && <td>
                      <span className='relative__elem'>{totalVisits - totalVisitsDiff}</span>
                    </td>}
                    {routesSettings.includes('diff') && <td>
                      <span className='relative__elem'>{totalVisitsDiff}</span>
                    </td>}
                    {routesSettings.includes('login') && <td>
                    </td>}
                    {routesSettings.includes('employeeStatus') && <td>
                    </td>}
                    {routesSettings.includes('routeType') && <td>
                    </td>}
                    {routesSettings.includes('vacancyName') && <td>
                    </td>}
                    {routesSettings.includes('vsv') && <td>
                    </td>}
                    {routesSettings.includes('supervisor') && <td>
                    </td>}
                    {routesSettings.includes('tt') &&
                      <td>
                        <span className='relative__elem'>{totalPlaces}</span>
                      </td>
                    }
                    {routesSettings.includes('visitsOnWeek') && <td>
                    </td>}
                    {routesSettings.includes('income') &&
                      <td>
                        <span className='relative__elem'>{totalIncome}</span>
                      </td>
                    }
                    {routesSettings.includes('plannedWage') &&
                      <td>
                        <span className='relative__elem'>{totalPlannedWage}</span>
                      </td>
                    }
                  </tr>
                </tfoot>
              )}
            </table>
            {((data && data !== null) && !data.length) && <div className='noData'>Нет данных</div>}
          </div>
        </div>

        <div className='pagination'>
          <div className='pagination__count'>Всего: {count}</div>
          <div className='pagination__str'>
            <span>Отображать строки</span>
            <LimitSelect limit={actualLimit} propsChange={handleChangeLimits} />
          </div>
          <Pagination
            setCurrentPage={setCurrentPage}
            setStartPage={setStartPage}
            handleChange={handleChange}
            currentPage={currentPage}
            pageName='userReports'
            startPage={startPage}
            count={count}
            limit={actualLimit}
          />
        </div>
      </div>
    </>
  );
};

export default TableProjectRoutes;
